define('models/causes/causeattribute',['backbone'
], function (Backbone) {
    var BankAccount = Backbone.Model.extend({

        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            else
                return null;
        },
        initialize: function (options) {
            options = options || {};

            this.instanceURL = options.instanceURL;
          //  this.AccountLoadAmount = options.ALA;
            this.AccountAttributeID = options.ATID;
            this.AccountAttributeValue = options.ATV;
           
        },
       
        parse: function (data) {
            var response = {};
            response.AccountAttributeID = data.ATID;
            response.AccountAttributeValue = data.ATV;
           // response.AccountLoadAmount = data.ALA;
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.ATID = this.attributes.AccountAttributeID;
            data.AID = this.attributes.AccountAttributeValue;
        //    data.ALA = this.attributes.AccountLoadAmount;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return BankAccount;
});

